import { useCallback } from "react";
import { ScrollView } from "tamagui";

import SignIn from "@/auth/SignIn";

const SidebarSignin = ({
  onClose,
  conversationId,
  onBackButtonChange,
  onContinue,
}: {
  onClose?: () => void;
  conversationId?: string;
  onBackButtonChange?: (show: boolean, onPress?: () => void) => void;
  onContinue?: () => void;
}) => {
  const handleBackButtonChange = useCallback(
    (visible: boolean, callback: (() => void) | null) => {
      onBackButtonChange?.(visible, callback ?? undefined);
    },
    [onBackButtonChange],
  );

  return (
    <ScrollView
      flex={1}
      contentContainerStyle={{
        flex: 1,
        alignItems: "center",
        paddingHorizontal: "$200",
        paddingBottom: "$400",
      }}
    >
      <SignIn
        isEmbedded
        conversationId={conversationId}
        onComplete={() => {
          onContinue?.();
        }}
        onBackButtonChange={handleBackButtonChange}
      />
    </ScrollView>
  );
};

export default SidebarSignin;
